import { render, staticRenderFns } from "./request-form.vue?vue&type=template&id=19ce3564"
import script from "./request-form.vue?vue&type=script&lang=js"
export * from "./request-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports